import { Config } from '../config'

export const resolveGrowthInfraRoute = (path: string) => {
  const baseUrl = Config.GROWTH_INFRA_API
  return `${baseUrl}/${path}`
}
